import React, { useEffect, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import styled from "@emotion/styled";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { CiMemoPad } from "react-icons/ci";
import SearchIcon from "@mui/icons-material/Search";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Stack,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  InputBase,
  TextField,
  MenuItem,
} from "@mui/material";
import {
  getMemos,
  deleteMemo,
  clearMemo,
  getMemosBySearch,
  getMemosByCategory,
} from "../../Context/features/memoSlice";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Backdrop } from "@mui/material";
import loaderImg from "../../assets/loader.gif";
import { getCategories } from "../../Context/features/categorySlice";

const Wrapper = styled(Box)(({ theme }) => ({
  height: "100vh",
  padding: theme.spacing(1),
  top: 0,
  [theme.breakpoints.up("sm")]: {
    paddingTop: theme.spacing(2),
  },
}));

const TableHeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: "bold",
  backgroundColor: "background.primary",
  color: "color.primary",
}));

const ContainerTable = styled(TableContainer)(({ theme }) => ({
  maxWidth: "100%",
}));

const Memos = () => {
  const { memos, allmemopagination, loadingallmemos, error } = useSelector((state) => ({ ...state.memo }));
  const { categories } = useSelector((state) => ({ ...state.category }));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const rowsPerPage = 24;
  const [openDialog, setOpenDialog] = useState(false);
  const [memoId, setMemoId] = useState();
  const [category_id, setCategory_id] = useState(0);
  const [isLoading, setIsLoading] = useState(false);



  const totalPages = allmemopagination?.totalPages || 1;

  // Pagination: Calculate visible page numbers (ellipsis style)
  const maxPagesToShow = 2;
  const pageNumbers = [];
  let startPage = Math.max(1, page - Math.floor(maxPagesToShow / 2));
  let endPage = Math.min(totalPages - 1, startPage + maxPagesToShow - 1);

  if (endPage - startPage < maxPagesToShow - 1) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

   useEffect(() => {
      dispatch(getMemos({ page: page + 1, limit: rowsPerPage }));;
    }, [dispatch, page]);

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  useEffect(() => {
    loadingallmemos && setIsLoading(loadingallmemos);
  }, [loadingallmemos]);

  useEffect(() => {
    error && toast.error(error);
  }, [error]);

    if (!memos.length) {
    return null;
  }

  //function called to view memo
  const handleView = (id) => {
    navigate(`/a_memoview/${id}`);
  };

  //function called to handle edit
  const handleDelete = (id) => {
    if (id) {
      setMemoId(id);
      setOpenDialog(true);
    }
  };

  //function called when any input  value is changed
    const onSearchChange = (e) => {
      const searchName = e.target.value;
      if (searchName.length > 3) {
        dispatch(clearMemo());
        dispatch(
          getMemosBySearch({
            searchName: {
              searchName,
            },
            page: 1,
            limit: 24
          })
        );
      } else {
        dispatch(getMemos({ page: 1, limit: 24 }));
      }
    };

  //function called when any input  value is changed
const onSearchCategory = (e) => {
  const searchCategory = e.target.value;
  setCategory_id(searchCategory);
  if (searchCategory) {
    dispatch(clearMemo());
    dispatch(getMemosByCategory({id: searchCategory, page: 1, limit: 72 }));
  } else {
    dispatch(getMemos({ page: 1, limit: 24 }));
  }
};


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        justifyItems: "center",
      }}
    >
      {isLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadingallmemos}
        >
          <img src={loaderImg} alt="Loading..." />
        </Backdrop>
      )}
      <Typography
        component="h4"
        variant="h4"
        textAlign="center"
        sx={{ fontWeight: "bold" }}
      >
        Memos
      </Typography>
      <Wrapper>
        <Box
          component={Paper}
          sx={{
            p: 2,
            mt: -2,
            mb: 2,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 10,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid gray",
              width: "100%",
            }}
          >
            <IconButton>
              <CiMemoPad />
            </IconButton>
            <InputBase
              sx={{ flexGrow: 1 }}
              placeholder="Search for Memo by Subject"
              name="searchName"
              onChange={onSearchChange}
              type="text"
              id="searchName"
            />
            <IconButton sx={{ p: "10px" }}>
              <SearchIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <TextField
              sx={{ width: "100%" }}
              id="category_id"
              select
              name="category_id"
              label="Search Memo By Category"
              value={category_id || ""}
              size="small"
              color="error"
              margin="dense"
              onChange={onSearchCategory}
            >
              <MenuItem>Select category</MenuItem>
              {categories.map((item, index) => (
                <MenuItem key={item.id * 190} value={item.id}>
                  {item.cat_name}
                </MenuItem>
              ))}
            </TextField>
            <IconButton sx={{ p: "10px" }}>
              <SearchIcon />
            </IconButton>
          </Box>
        </Box>
        <ContainerTable component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableHeaderCell>
                  <Typography variant="h6">#</Typography>
                </TableHeaderCell>
                <TableHeaderCell>
                  <Typography variant="h6">SUBJECT</Typography>
                </TableHeaderCell>
                <TableHeaderCell>
                  <Typography variant="h6">RAISED BY</Typography>
                </TableHeaderCell>
                <TableHeaderCell>
                  <Typography variant="h6">CATEGORY</Typography>
                </TableHeaderCell>
                <TableHeaderCell>
                  <Typography variant="h6">STATUS</Typography>
                </TableHeaderCell>
                <TableHeaderCell>
                  <Typography variant="h6">DEPT</Typography>
                </TableHeaderCell>
                <TableHeaderCell>
                  <Typography variant="h6">ACTIONS</Typography>
                </TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {memos
                .map((row, index) => (
                  <TableRow
                    key={row.id + 50}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      <Typography>{index + 1}</Typography>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Typography>{row.subject.toUpperCase()}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>{row.firstname}</Typography>
                      <Typography>{row.lastname}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>{row.cat_name}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        style={{
                          backgroundColor:
                            (row.status === "Approved" && "green") ||
                            (row.status === "Pending" && "orange") ||
                            (row.status === "Rejected" && "red"),
                          padding: "3px 10px",
                          alignItems: "center",
                          borderRadius: 8,
                          color: "white",
                          display: "inline-block",
                        }}
                      >
                        {row.status}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>{row.dept_name}</Typography>
                    </TableCell>
                    <TableCell>
                      {/* Actions */}
                      <Stack
                        direction="row"
                        spacing={0.1}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <IconButton
                          color="error"
                          onClick={() => {
                            handleView(row.memo_id);
                          }}
                        >
                          <VisibilityIcon />
                        </IconButton>
                        <IconButton
                          aria-label="delete"
                          color="error"
                          onClick={() => {
                            handleDelete(row.memo_id);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>

           {/* Pagination Controls */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "20px",
                    gap: "10px",
                  }}
                >
                  {/* Prev arrow button */}
                  <IconButton
                    onClick={() => handleChangePage(page - 1)}
                    disabled={page === 0}
                    sx={{
                      border: "1px solid #344054",
                      borderRadius: "50%",
                      width: 40,
                      height: 40,
                    }}
                  >
                    <ArrowBack sx={{ color: page === 0 ? "#ccc" : "#344054" }} />
                  </IconButton>
          
                  {/* Page Numbers with Ellipsis */}
                  <Box display="flex" alignItems="center">
                    {/* Always show first page */}
                    {startPage > 0 && (
                      <>
                        <Button
                          onClick={() => handleChangePage(0)}
                          sx={{
                            color: page === 0 ? "#1D2939" : "#667085",
                            fontFamily: "Outfit, sans-serif",
                            fontSize: "12px",
                          }}
                        >
                          1
                        </Button>
                        {startPage > 1 && (
                          <Box
                            sx={{
                              fontSize: "12px",
                              color: "#667085",
                              fontFamily: "Outfit, sans-serif",
                            }}
                          >
                            ...
                          </Box>
                        )}
                      </>
                    )}
          
                    {/* Middle pages */}
                    {pageNumbers.map((pageNumber) => (
                      <Button
                        key={pageNumber}
                        onClick={() => handleChangePage(pageNumber)}
                        sx={{
                          color: page === pageNumber ? "#1D2939" : "#667085",
                          fontFamily: "Outfit, sans-serif",
                          fontSize: "12px",
                          fontWeight: page === pageNumber ? "bold" : "normal",
                        }}
                      >
                        {pageNumber + 1}
                      </Button>
                    ))}
          
                    {/* Always show last page */}
                    {endPage < totalPages - 1 && (
                      <>
                        {endPage < totalPages - 2 && (
                          <Box
                            sx={{
                              fontSize: "12px",
                              color: "#667085",
                              fontFamily: "Outfit, sans-serif",
                            }}
                          >
                            ...
                          </Box>
                        )}
                        <Button
                          onClick={() => handleChangePage(totalPages - 1)}
                          sx={{
                            color: page === totalPages - 1 ? "#1D2939" : "#667085",
                            fontFamily: "Outfit, sans-serif",
                            fontSize: "12px",
                          }}
                        >
                          {totalPages}
                        </Button>
                      </>
                    )}
                  </Box>
          
                  {/* Next arrow button */}
                  <IconButton
                    onClick={() => handleChangePage(page + 1)}
                    disabled={page >= totalPages - 1}
                    sx={{
                      border: "1px solid #344054",
                      borderRadius: "50%",
                      width: 40,
                      height: 40,
                    }}
                  >
                    <ArrowForward sx={{ color: page >= totalPages - 1 ? "#ccc" : "#344054" }} />
                  </IconButton>
                </Box>
        </ContainerTable>
        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            Are you sure you want to delete this memo ?
          </DialogTitle>
          <DialogActions>
            <Button
              autoFocus
              color="error"
              onClick={() => setOpenDialog(false)}
            >
              Disagree
            </Button>
            <Button
              color="success"
              onClick={() => {
                dispatch(deleteMemo({ memoId, toast }));
                setTimeout(() => {
                  setOpenDialog(false);
                  dispatch(getMemos({ page: page + 1, limit: rowsPerPage }));
                }, 500);
              }}
              autoFocus
            >
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </Wrapper>
    </Box>
  );
};

export default Memos;
